

/**
 * 动态加载JavaScript文件
 * 
 * 此函数用于在运行时动态加载一个JavaScript文件，并可选择性地执行一个回调函数当脚本加载完成时
 * 它通过创建一个script元素，设置其src属性为指定的jsPath，然后将其添加到document.body中来实现
 * 
 * @param jsPath 需要加载的JavaScript文件的URL
 * @param callback 可选参数，一个事件监听器或事件监听对象，当脚本加载完成时会被调用
 * @param errorCallback 可选参数，一个事件监听器或事件监听对象，当脚本加载完成时会被调用
 */
export const loadJs = (src: string, attrs?: Object, parentNode?: Node) => {

  return new Promise<HTMLScriptElement>((resolve, reject) => {

    const script = document.createElement('script')
    script.async = true
    script.src = src

    for (const [k, v] of Object.entries(attrs || {})) {
      script.setAttribute(k, v)
    }

    onload = () => {
      resolve(script)
    }
    onerror = () => {
      reject(new Error(`Failed to load ${src}`))
    }

    script.addEventListener("load", onload);
    script.addEventListener("error", onerror);

    const node = parentNode || document.head || document.getElementsByTagName('head')[0]
    node.appendChild(script)
  })
}
